export default {
  'menu.welcome': 'ようこそ',
  'menu.entity': 'エンティティ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.login': 'ログイン',
  'menu.register': '登録',
  'menu.register-result': '登録結果',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': 'アプリ',
  'menu.dashboard.monitor': 'モニター',
  'menu.flow': 'フロー',
  'menu.divider': '区切り線',
  'menu.dashboard.workplace': 'ワークプレイス',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（振込情報の入力）',
  'menu.form.step-form.confirm': 'ステップフォーム（振込情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完了）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト（記事）',
  'menu.list.search-list.projects': '検索リスト（プロジェクト）',
  'menu.list.search-list.applications': '検索リスト（アプリケーション）',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '詳細プロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.settings': 'アカウント設定',
  'menu.account.trigger': 'エラーを発生させる',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディター',
  'menu.editor.flow': 'フローエディター',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'Koni エディター',
  'menu.user-management': 'ユーザー',
  'menu.tag-management': 'タグ',
  'menu.canned-response': '定型文',
  'menu.chatrooms': 'チャットルーム',
  'menu.email': 'メール',
  'menu.core': 'コア機能',
  'menu.files': 'ファイル',
  'menu.filesNew': 'ファイル（新）',
  'menu.filesRefactored': 'ファイル（リファクタ版）',
  'menu.favouritesHub': '案件',
  'menu.library': 'プロンプトライブラリ',
  'menu.chat': 'チャット',
  'menu.search': '検索',
  'menu.specialised': '専門機能',
  'menu.app': 'アプリ',
  'menu.playbook': 'ワークスタジオ',
  'menu.template': 'カスタム出力',
  'menu.quote': '見積',
  'menu.review': 'レビュー',
  'menu.sideBySide': '並べて比較',
  'menu.grading': '採点',
  'menu.setting': '設定',
  'menu.diagnostics': '診断',
  'menu.context': 'コンテキスト',
  'menu.management': '管理',
  'menu.conversation': '会話',
  'menu.translation': '翻訳',
  'menu.broadcast': 'ブロードキャスト',
  'menu.dictionary': '辞書',
  'menu.question': '質問',
  'menu.nlp': 'NLP',
  'menu.form.new-flow': '新規フロー',
  'menu.form.update-flow': 'フローを編集',
  'menu.list.flow-list': 'フロー一覧',
  'menu.comparison': '比較',
  'menu.scribe': 'スクライブ',
  'menu.organisation': '組織',
  'menu.superAdminOrganisation': 'スーパー管理者組織',
  'menu.section.vault': 'ボールト',
  'menu.section.chatAndCompose': 'チャットと作成',
  'menu.section.specialised': '専門機能',
  'menu.section.system': 'システム',
};
